var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_2605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 12C0.5 11.5266 0.883756 11.1429 1.35714 11.1429H23.6429C24.1162 11.1429 24.5 11.5266 24.5 12C24.5 12.4734 24.1162 12.8571 23.6429 12.8571H1.35714C0.883756 12.8571 0.5 12.4734 0.5 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0368 5.3939C17.3715 5.05917 17.9142 5.05917 18.2489 5.3939L24.2489 11.3939C24.5837 11.7286 24.5837 12.2714 24.2489 12.6061L18.2489 18.6061C17.9142 18.9408 17.3715 18.9408 17.0368 18.6061C16.702 18.2714 16.702 17.7286 17.0368 17.3939L22.4307 12L17.0368 6.60609C16.702 6.27135 16.702 5.72864 17.0368 5.3939Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_2605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightNeutral);
export default __webpack_public_path__ + "static/media/arrow-right-neutral.a654c8236b01b2f54d1428f032040e04.svg";
export { ForwardRef as ReactComponent };